import { render, staticRenderFns } from "./StudentDocInfoPassport.vue?vue&type=template&id=52c62736&scoped=true&"
import script from "./StudentDocInfoPassport.vue?vue&type=script&lang=ts&"
export * from "./StudentDocInfoPassport.vue?vue&type=script&lang=ts&"
import style0 from "./StudentDocInfoPassport.vue?vue&type=style&index=0&id=52c62736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c62736",
  null
  
)

export default component.exports